/* eslint-disable no-useless-computed-key */
import DownloadIcon from '@mui/icons-material/Download';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Card from '../../../components/layout/Card';
import { Flex, Grid, MarginHandler } from '../../../styledComponents';
import ButtonCom from '../../../components/button/ButtonCom';
import TransitionsModal from '../../../components/modal/Modal';
import InputControl from '../../../components/input/InputControl';
import { FormControlLabel, Checkbox, FormGroup, FormControl, FormLabel, IconButton, Tooltip, Box, Typography, Button, InputLabel, MenuItem, LinearProgress, CircularProgress, Chip, Switch, TextField, Collapse } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import FilterListIcon from '@mui/icons-material/FilterList';
import ClearIcon from '@mui/icons-material/Clear';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { colors, fonts } from '../../../utils';
import { endPoints } from '../../../api/apiEndpoints';
import { Api } from '../../../api/api';
// import { setAllPostCategories } from '../../../redux/slices/posts/posts';
import { setAllDocuments } from '../../../redux/slices/shareholderRights/shareholderRights';
import { errorNotify, successNotify } from '../../../utils/helper';
import Table from '../../../components/table/Table';
import EditIcon from '@mui/icons-material/Edit';
import ImageIcon from '@mui/icons-material/Image';
import DeleteIcon from '@mui/icons-material/Delete';
import AddBoxIcon from '@mui/icons-material/AddBox';
import { useNavigate } from 'react-router-dom';
import DeleteModal from '../../../components/deletemodal/DeleteModal';
import moment from 'moment';
import { setAllCourses, setAllCoursesCategoriesList } from '../../../redux/slices/shareholderEducation/shareholderEducation';
import Editor from 'react-simple-wysiwyg';
import FilledSelectOption from '../../../components/input/FilledSelectOption';
import Select from 'react-select';
import ReadMoreReact from 'read-more-react/dist/components/ReadMoreReact';


const Courses = () => {
	const dispatch = useDispatch();
	const { clientId, userId, fullName } = useSelector((state) => state?.activeAccount);
	const { primaryFont } = fonts;

	const { colorWhite, colorPrimary, colorGreenGradient } = colors;

	const { courses, coursesCategoriesList } = useSelector((state) => state.shareHolderEducation);

	const [openModal, setOpenModal] = useState(false);
	const [isLoading, setIsLoading] = useState(false);
	const [openDeleteModal, setOpenDeleteModal] = useState(false);
	const [isEditing, setIsEditing] = useState(false);
	const [isLoadingDoc, setIsLoadingDoc] = useState(false);
	const [disableUpload, setDisableUpload] = useState(false);
	const [disableUrlInput, setDisableUrlInput] = useState(false);
	const [isLoadingDocUr, setIsLoadingDocUr] = useState(false);
	const [disableUploadUr, setDisableUploadUr] = useState(false);
	const [disableUrlInputUr, setDisableUrlInputUr] = useState(false);
	const [isLoadingImg, setIsLoadingImg] = useState(false);
	const [isLoadingCertificate, setIsLoadingCertificate] = useState(false);
	const [isLoadingThumbnail, setIsLoadingThumbnail] = useState(false);

	const [selectedCategories, setSelectedCategories] = useState(null);
	const [isPaid, setIsPaid] = useState(false);

	const [formData, setFormData] = useState({
		module: '',
		short_description: '',
		thumbnail: '',
		video_link: '',
		learning_objectives: '',
		passing_marks:50
	});
	const [currentParams, setCurrentParams] = useState({
		limit: 10,
		page: 1,
		totalPages: 0,
		totalRecords: 0,
	});
	const [filters, setFilters] = useState({
		search: '',
		category_id: '',
		status: '',
		date_from: null,
		date_to: null,
	});
	const [filtersOpen, setFiltersOpen] = useState(false);

	const handleFilterChange = (e) => {
		setFilters((prevState) => ({
			...prevState,
			[e.target.name]: e.target.value,
		}));
	};

	const handleFilterDateChange = (name, value) => {
		setFilters((prevState) => ({
			...prevState,
			[name]: value,
		}));
	};

	const handleApplyFilters = () => {
		getData(currentParams.limit, 1, filters);
	};

	const handleClearFilters = () => {
		const clearedFilters = {
			search: '',
			category_id: '',
			status: '',
			date_from: null,
			date_to: null,
		};
		setFilters(clearedFilters);
		getData(currentParams.limit, 1, clearedFilters);
	};

	const handleCloseModal = () => {
		setOpenModal(false);
		setIsEditing(false);
	};

	const handleChange = (e) => {
		setFormData((prevState) => ({
			...prevState,
			[e.target.name]: e.target.value,
		}));
	};

	const getData = async (limit, page, filterParams = filters) => {
		setIsLoading(true)
		try {

			await Api.post(endPoints?.shareHolderEducation?.fetchCourse,
				{
					"status": filterParams.status || "all",
					"limit": limit || 10,
					"page": page || 1,
					"search": filterParams.search || null,
					"category_id": filterParams.category_id || null,
					"date_from": filterParams.date_from ? dayjs(filterParams.date_from).format('YYYY-MM-DD') : null,
					"date_to": filterParams.date_to ? dayjs(filterParams.date_to).format('YYYY-MM-DD') : null,
				}, {
				headers: {
					'xt-user-token': null
				}
			})
				.then((response) => {
					dispatch(
						setAllCourses(
							response?.data?.data?.courses?.courses?.map((d, index) => ({
								index: index + 1,
								id: d?.id,
								module: d?.module,
								video_link: d?.video_link,
								short_description: d?.short_description,
								picture: d?.picture,
								learning_objectives: d?.learning_objectives,
								mode_of_learning: d?.mode_of_learning,
								dt: d?.dt,
								creator_name: d?.creator_name,
								is_enabled: d?.is_enabled,
								thumbnail: d?.thumbnail,
								is_paid: d?.is_paid,
								certificate_img: d?.certificate_img,
								category_ids: d?.category_ids,
								category_names: d?.category_names,
								passing_marks: d?.passing_marks,
							})
							),
						),
					);
					const { page, limit, totalPages, totalRecords } = response?.data?.data?.courses?.pagination;
					setCurrentParams({ page, limit, totalPages, totalRecords });
					setIsLoading(false)

				})
				.catch((error) => {
					// if (error?.response?.status === 400) {
					// 	errorNotify(error?.response?.data);
					// 	setDisabledBtn(false);
					// }
					// setErrMsg(error?.response?.data?.message || errorMsg);
				});
		} catch (err) {
			// setErrMsg('Login Failed');
			// setDisabledBtn(false);
		}
	};

	const getCoursesCategories = async () => {
		setIsLoading(true)
		try {

			await Api.post(endPoints?.courseCategory?.fetch,
				{
					"limit": 100,
					"page": 1
				}, {
				headers: {
					'xt-user-token': null
				}
			})
				.then((response) => {
					dispatch(
						setAllCoursesCategoriesList(
							response?.data?.data?.categories?.categories?.map((d, index) => ({
								// id: d?.id,
								// description: d?.description,
								value: d?.id,
								label: d?.name
							})
							),
						),
					);
					setIsLoading(false)

				})
				.catch((error) => {
					// if (error?.response?.status === 400) {
					// 	errorNotify(error?.response?.data);
					// 	setDisabledBtn(false);
					// }
					// setErrMsg(error?.response?.data?.message || errorMsg);
				});
		} catch (err) {
			// setErrMsg('Login Failed');
			// setDisabledBtn(false);
		}
	};

	const handleCreateModal = () => {
		setFormData({ module: '' })
		setOpenModal(true)
		setIsEditing(false);
	};
	const handleEditModal = (val) => {
		const { module, id, short_description, picture, category_ids, passing_marks, certificate_img, learning_objectives, video_link, thumbnail, is_enabled } = val;

		setFormData({
			module,
			id,
			short_description,
			picture,
			certificate_img,
			// mode_of_learning,
			learning_objectives,
			video_link,
			thumbnail,
			is_enabled,
			passing_marks

		});
		if (category_ids) {
			let catArr = category_ids?.split(",");

			let tempArr = [];
			catArr.map((val) => {
				coursesCategoriesList?.map((cat) => {
					if (val == cat.value) {
						return tempArr.push({ label: cat.label, value: cat.value });
					}
				});
			});
			setSelectedCategories(tempArr);
		}
		setOpenModal(true)
		setIsEditing(true);
	};


	const handleSubmit = async () => {
		if (!isEditing) {

			const categoriesVal = selectedCategories?.map((e) => e.value)

			try {

				await Api.post(endPoints?.shareHolderEducation?.createCourse, {
					...formData,
					creator_id: userId,
					creator_name: fullName,
					category_ids: categoriesVal,
					is_paid: isPaid
				}, {
					headers: {
						'xt-user-token': null
					}
				})
					.then((response) => {
						handleCloseModal();
						getData();
						successNotify("Course Created Successfully")

					})
					.catch((error) => {

					});

			} catch (err) {
			}

		} else {


			try {

				await Api.post(endPoints?.shareHolderEducation?.updateCourse, {
					...formData,
					creator_id: userId,
					creator_name: fullName,
					is_paid: isPaid
				}, {
					headers: {
						'xt-user-token': null
					}
				})
					.then((response) => {
						handleCloseModal();
						getData();
						successNotify("Course Updated Successfully")

					})
					.catch((error) => {

					});

			} catch (err) {
			}
		}
	};

	useEffect(() => {
		getData();
		getCoursesCategories();
	}, [])

	const handleImageUpload = (event) => {
		setIsLoadingImg(true)
		if (event.target.files.length > 0) {
			let formData = new FormData();
			let file = event.target.files[0];
			let fileName = file.name.replace(/\s/g, '');
			let timestampedFileName = `${new Date().getTime()}_${fileName}`;

			formData.append('file', file, timestampedFileName);
			Api.post(endPoints?.file?.upload, formData, {
				headers: {
					'Content-Type': 'multipart/form-data',
					'xt-user-token': null
				}
			})
				.then((response) => {
					setIsLoadingImg(false)
					setFormData((prevState) => ({
						...prevState,
						picture: response.data.data.link,
					}));
					successNotify("Image Uploaded Successfully")

				})
				.catch((error) => {

					errorNotify(error?.response?.data?.message
						? error?.response.data.message
						: "something went wrong");

				});

			// setErrMsg('Login Failed');

		}
	};
	const handleThumbnailUpload = (event) => {
		setIsLoadingThumbnail(true)
		if (event.target.files.length > 0) {
			let formData = new FormData();
			let file = event.target.files[0];
			let fileName = file.name.replace(/\s/g, '');
			let timestampedFileName = `${new Date().getTime()}_${fileName}`;

			formData.append('file', file, timestampedFileName);
			Api.post(endPoints?.file?.upload, formData, {
				headers: {
					'Content-Type': 'multipart/form-data',
					'xt-user-token': null
				}
			})
				.then((response) => {
					setIsLoadingThumbnail(false)
					setFormData((prevState) => ({
						...prevState,
						thumbnail: response.data.data.link,
					}));
					successNotify("Thumbnail Uploaded Successfully")

				})
				.catch((error) => {
					errorNotify(error?.response?.data?.message
						? error?.response.data.message
						: "something went wrong");
				});
		}
	};
	const handleCertificateUpload = (event) => {
		setIsLoadingCertificate(true)
		if (event.target.files.length > 0) {
			let formData = new FormData();
			let file = event.target.files[0];
			let fileName = file.name.replace(/\s/g, '');
			let timestampedFileName = `${new Date().getTime()}_${fileName}`;

			formData.append('file', file, timestampedFileName);
			Api.post(endPoints?.file?.upload, formData, {
				headers: {
					'Content-Type': 'multipart/form-data',
					'xt-user-token': null
				}
			})
				.then((response) => {
					setIsLoadingCertificate(false)
					setFormData((prevState) => ({
						...prevState,
						certificate_img: response.data.data.link,
					}));
					successNotify("Certificate Uploaded Successfully")

				})
				.catch((error) => {

					errorNotify(error?.response?.data?.message
						? error?.response.data.message
						: "something went wrong");


					// if (error?.response?.status === 400) {
					// 	errorNotify(error?.response?.data);
					// 	setDisabledBtn(false);
					// }
					// setErrMsg(error?.response?.data?.message || errorMsg);
				});

			// setErrMsg('Login Failed');

		}
	};
	const handleSwitchClick = (event) => {
		event.stopPropagation();
	};

	const handleChangeTableSwitch = async (event, val) => {

		try {

			await Api.post(endPoints?.shareHolderEducation?.deleteCourse, {
				id: val.id,
				status: event.target.checked,
			}, {
				headers: {
					'xt-user-token': null
				}
			})
				.then((response) => {
					successNotify("Course Status Updated Successfully")
					getData();

				})
				.catch((error) => {

				});

		} catch (err) {
		}

	};

	const column = [
		{
			title: 'Id',
			field: 'id',
			render: (rowData) => <h4 className='font-face-R'>{rowData?.id}</h4>,
		},
		// {
		// 	title: 'Category Id',
		// 	field: 'category_ids',
		// 	render: (rowData) => <h4 className='font-face-B'>{rowData?.category_ids}</h4>,
		// },
		{
			title: 'Title',
			field: 'module',
			render:  (rowData) => <h4 className='font-face-R'>{
				rowData?.module?.length > 15 ?
					<ReadMoreReact
						text={rowData?.module}
						min={10}
						ideal={15}
						max={rowData?.module?.length}
						readMoreText="Read More"
					/> : rowData?.module}</h4>,
		},
		{
			title: 'Description',
			field: 'short_description',
			width: "10%",
			render: (rowData) => <h4 className='font-face-R'>{
				rowData?.short_description?.length > 15 ?
					<ReadMoreReact
						text={rowData?.short_description}
						min={10}
						ideal={15}
						max={rowData?.short_description?.length}
						readMoreText="Read More"
					/> : rowData?.short_description}</h4>,
		},
		{
			title: 'Categories',
			field: 'category_names',
			render: (rowData) => <h4 className='font-face-R'>{rowData?.category_names}</h4>,
		},
		{
			title: 'Creator',
			field: 'creator_name',
			render: (rowData) => <h4 className='font-face-R'>{rowData?.creator_name}</h4>,
		},
		{
			title: 'Date',
			field: 'dt',
			render: (rowData) => <h4 className='font-face-R'>{moment(rowData?.dt).format("DD-MM-YYYY")}</h4>,
		},
		{
			title: 'Edit',
			field: 'edit',
			filtering: false,
			render: (rowData) => (
				<Tooltip title='Edit'>
					<IconButton onClick={() => handleEditModal(rowData)} aria-label='Edit'>
						<EditIcon />
					</IconButton>
				</Tooltip>
			),
		},
		{
			title: 'Status',
			field: 'is_enabled',
			render: (rowData) =>
				<Switch onClick={handleSwitchClick} onChange={(event) => handleChangeTableSwitch(event, rowData)} checked={rowData?.is_enabled} name='enabled' />,
		},

	];

	const modeOptions = [{
		id: "online",
		description: "Online"
	}, {
		id: "offline",
		description: "Offline"
	}]

	return (
		<>

			<Card margin='3rem 1.5rem' padding='3rem'>

				<Flex jc='flex-end' gap='1rem' mb='2rem' fw='wrap'>
					<ButtonCom onClickHandler={handleCreateModal} btnTitle={"Create"} />
				</Flex>

				{/* Filters Section */}
				<Box sx={{ mb: 3, backgroundColor: '#f5f5f5', borderRadius: '8px', overflow: 'hidden' }}>
					<Box
						sx={{
							p: 2,
							cursor: 'pointer',
							display: 'flex',
							justifyContent: 'space-between',
							alignItems: 'center',
							'&:hover': { backgroundColor: '#ebebeb' },
							transition: 'background-color 0.2s ease'
						}}
						onClick={() => setFiltersOpen(!filtersOpen)}
					>
						<Flex ai='center' gap='0.5rem'>
							<FilterListIcon sx={{ color: '#666' }} />
							<Typography variant='h6' sx={{ fontSize: '1.6rem', fontWeight: 600, color: '#333' }}>
								Filter Courses
							</Typography>
						</Flex>
						{filtersOpen ? <ExpandLessIcon sx={{ color: '#666' }} /> : <ExpandMoreIcon sx={{ color: '#666' }} />}
					</Box>

					<Collapse in={filtersOpen} timeout={300}>
						<Box sx={{ p: 2, pt: 1 }}>
							{/* Quick Category Filters */}
							<Box sx={{ mb: 2 }}>
								<Typography sx={{ fontSize: '1.2rem', color: '#666', mb: 1 }}>
									Quick Filters:
								</Typography>
								<Flex gap='0.8rem' fw='wrap'>
									{coursesCategoriesList?.map((cat) => (
										<Chip
											key={cat.value}
											label={cat.label}
											onClick={() => {
												setFilters((prev) => ({ ...prev, category_id: cat.value }));
												getData(currentParams.limit, 1, { ...filters, category_id: cat.value });
											}}
											color={filters.category_id === cat.value ? 'success' : 'default'}
											variant={filters.category_id === cat.value ? 'filled' : 'outlined'}
											sx={{ fontSize: '1.1rem', cursor: 'pointer' }}
										/>
									))}
								</Flex>
							</Box>

							{/* Search Bar */}
							<Box sx={{ mb: 2 }}>
								<InputControl
									state={filters.search}
									onChange={handleFilterChange}
									label='Search by Title'
									name='search'
								/>
							</Box>

							{/* Dropdown Filters */}
							<Grid gtc='repeat(auto-fit, minmax(18rem, 1fr))' gap='1.5rem'>
								<FilledSelectOption
									label='Status'
									state={filters.status}
									onChange={handleFilterChange}
									options={[
										{ id: 'all', description: 'All' },
										{ id: 'true', description: 'Active' },
										{ id: 'false', description: 'Inactive' },
									]}
									maxWidth='100%'
									minWidth='100%'
									width='100%'
									name='status'
								/>
								<LocalizationProvider dateAdapter={AdapterDayjs}>
									<DesktopDatePicker
										label='Date From'
										value={filters.date_from}
										onChange={(value) => handleFilterDateChange('date_from', value)}
										renderInput={(params) => <TextField {...params} size='small' />}
									/>
								</LocalizationProvider>
								<LocalizationProvider dateAdapter={AdapterDayjs}>
									<DesktopDatePicker
										label='Date To'
										value={filters.date_to}
										onChange={(value) => handleFilterDateChange('date_to', value)}
										renderInput={(params) => <TextField {...params} size='small' />}
									/>
								</LocalizationProvider>
							</Grid>

							<Flex jc='space-between' ai='center' gap='1rem' mt='1.5rem'>
								<Button
									variant='text'
									startIcon={<ClearIcon />}
									onClick={handleClearFilters}
									sx={{ fontSize: '1.2rem', textTransform: 'none', color: '#666' }}>
									Clear All
								</Button>
								<Button
									variant='contained'
									color='success'
									startIcon={<SearchIcon />}
									onClick={handleApplyFilters}
									sx={{ fontSize: '1.2rem', textTransform: 'none', px: 3 }}>
									Apply Filters
								</Button>
							</Flex>
						</Box>
					</Collapse>
				</Box>

				<Flex jc='flex-end' gap='1rem' mb='2rem' fw='wrap'>

					<TransitionsModal
						open={openModal}
						// handleOpen={handleOpenModal}
						handleClose={handleCloseModal}
						modalTitle={isEditing ? "Edit Course" : "Create Course"}
					>

						<Grid gtc='repeat(auto-fit, minmax(40rem, 1fr))' padding='2rem'>
							<MarginHandler width='100%'>
								<InputControl
									state={formData?.module}
									onChange={handleChange}
									// inputProps={{ maxLength:150 }}
									label='Title'
									name='module'
								/>
							</MarginHandler>
							<MarginHandler width='100%'>
								<InputControl
									state={formData?.short_description}
									onChange={handleChange}
									// inputProps={{ maxLength: 250 }}
									label='Description'
									name='short_description'
								/>
							</MarginHandler>
							<MarginHandler width='100%'>
								<InputControl
									state={formData?.video_link}
									onChange={handleChange}
									label='Video Link'
									name='video_link'
								/>
							</MarginHandler>

							<MarginHandler width='100%'>
								<div style={{ marginBottom: "10px" }}>

									<label>Learning Objectives</label>
								</div>
								<Editor value={formData?.learning_objectives} name='learning_objectives' onChange={handleChange} />
							</MarginHandler>
							<MarginHandler width='100%'>
								<InputControl
									state={formData?.passing_marks}
									onChange={handleChange}
									label='Passing Marks'
									name='passing_marks'
									type="number"
								/>
							</MarginHandler>

							{/* <FilledSelectOption
								label='Select Category'
								initalStateNotShow
								state={formData.category_ids}
								onChange={handleChange}
								options={coursesCategoriesList}
								maxWidth='100%'
								minWidth='100%'
								width='100%'
								name='category_ids'
							/> */}

							<Select
								defaultValue={selectedCategories}
								onChange={setSelectedCategories}
								options={coursesCategoriesList}
								isMulti
								placeholder="Select Categories"
								styles={{
									control: (baseStyles, state) => ({
										...baseStyles,
										// borderColor: state.isFocused ? 'grey' : 'red',
										// marginTop: "15px",
										minHeight: "50px",
										minWidth: "200px",
										// marginBottom: "15px",
										fontSize: "13px"
									}),
								}}
							/>


							{isLoadingImg ?
								<CircularProgress sx={{ margin: "auto" }} color="success" />
								:
								<>
									<input
										accept=".jpeg, .jpg, .png"
										style={{ display: 'none' }}
										id="image-upload"
										type="file"
										onChange={(event) => handleImageUpload(event)}
									/>
									<label htmlFor="image-upload">
										<Button
											variant="contained"
											component="span"
											fullWidth
											color='success'
											style={{ fontSize: '1em' }}
										>
											Upload Image
										</Button>
									</label>
									{formData?.picture &&
										<img height={200} style={{ margin: "auto" }} src={formData?.picture} />
									}
								</>}
							{isLoadingThumbnail ?
								<CircularProgress sx={{ margin: "auto" }} color="success" />
								:
								<>
									<input
										accept=".jpeg, .jpg, .png"
										style={{ display: 'none' }}
										id="thumbnail-upload"
										type="file"
										onChange={(event) => handleThumbnailUpload(event)}
									/>
									<label htmlFor="thumbnail-upload">
										<Button
											variant="contained"
											component="span"
											fullWidth
											color='success'
											style={{ fontSize: '1em' }}
										>
											Upload Thumbnail
										</Button>
									</label>
									{formData?.thumbnail &&
										<img height={200} style={{ margin: "auto" }} src={formData?.thumbnail} />
									}
								</>}
							{/* <MarginHandler width='100%'>
								<InputControl
									state={formData?.thumbnail}
									onChange={handleChange}
									label='Thumbnail'
									name='thumbnail'
								/>
							</MarginHandler> */}

							{isLoadingCertificate ?
								<CircularProgress sx={{ margin: "auto" }} color="success" />
								:
								<>
									<input
										accept=".jpeg, .jpg, .png"
										style={{ display: 'none' }}
										id="certificate-upload"
										type="file"
										onChange={(event) => handleCertificateUpload(event)}
									/>
									<label htmlFor="certificate-upload">
										<Button
											variant="contained"
											component="span"
											fullWidth
											color='success'
											style={{ fontSize: '1em' }}
										>
											Upload Certificate
										</Button>
									</label>
									{formData?.certificate_img &&
										<img height={200} style={{ margin: "auto" }} src={formData?.certificate_img} />
									}
								</>}

							{/* <MarginHandler>
								<FilledSelectOption
									label='Type *'
									state={formData?.mode_of_learning}
									onChange={(e) => {
										setFormData({ ...formData, mode_of_learning: e.target.value });
									}}
									options={modeOptions}
									width='18rem'
									name='type'
								/>
							</MarginHandler> */}

							<MarginHandler>
								<FormControlLabel control={<Checkbox sx={{
									'& .MuiSvgIcon-root': { fontSize: 22 }
								}} onChange={(e) => setIsPaid(e.target.checked)} checked={isPaid} />} label="Paid" />

							</MarginHandler>



							<MarginHandler mt="2rem">
								<Button
									color='primary'
									variant='contained'
									onClick={handleSubmit}
									style={{
										// backgroundColor: colorPrimary,
										background: colorGreenGradient,
										fontSize: '1.6rem',
										textTransform: 'none',
										padding: '0.7rem 2rem',
										color: colorWhite,
										borderRadius: '0.5rem',
										float: "right"
									}}
									disabled={!formData.module || !formData.thumbnail || !formData.video_link || !selectedCategories}
									className='font-face-R'>
									{isEditing ? "Update " : "Create "}
								</Button>
							</MarginHandler>

						</Grid>
					</TransitionsModal>
				</Flex>



				{isLoading ?
					<Box sx={{ m: '5rem' }}>
						<LinearProgress color="success" />
					</Box>
					:
					<Table
						columns={column}
						tableData={courses?.map((item) => ({ ...item }))}
						sorting
						columnsButton
						padding="3rem"
						showTitle
						paginationType='normal'
						titleHeading="Courses"
						showToolbar={true}
						pageSize={currentParams.limit}
						onChangeRowsPerPage={(event) => getData(parseInt(event.target.value, 10), 1)}
						totalRecords={currentParams.totalRecords}
						handlePageChange={(event, newPage) => getData(currentParams.limit, newPage + 1)}
						curPage={currentParams.page - 1}
					/>
				}








			</Card>
		</>
	);
};

export default Courses;
